import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Carousel from 'components/common/Carousel';
import LetterButton from './LetterButton';
import useAppLayout from 'state/hooks/use-app-layout';
import { LetterBookBadgeDict, LetterBookBadgeIdToLetterDict } from 'util/assignment-badge-util';

type Props = {
  selectedLetter: string | undefined;
  letterSelectedCallback: (letter: string) => void;
};

const LetterSelector: React.FC<Props> = ({ selectedLetter, letterSelectedCallback }) => {
  const { offset } = useAppLayout();
  const classes = useStyles({ offset });

  return (
    <Box className={classes.letterSelectorContainer}>
      <Carousel>
        {Object.keys(LetterBookBadgeDict).map((id) => {
          return (
            <LetterButton
              selected={LetterBookBadgeIdToLetterDict[id] === selectedLetter}
              key={id}
              letterId={parseInt(id)}
              letterSelectedCallback={letterSelectedCallback}
            />
          );
        })}
      </Carousel>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  letterSelectorContainer: {
    marginLeft: ({ offset }: any) => theme.typography.pxToRem(-offset.left),
    marginRight: ({ offset }: any) => theme.typography.pxToRem(-offset.left),
  },
}));

export default LetterSelector;
